import React from 'react';
import { PageHeader } from '../../components/ui/page-header';
import DatabaseBackupRestore from '../../components/DatabaseBackupRestore';
import { Card, CardContent } from '../../components/ui';
import { useAuth } from '../../context/AuthContext';

const DatabasePage: React.FC = () => {
  const { hasPermission } = useAuth();
  
  // Check if user has database_manage permission
  if (!hasPermission('database_manage')) {
    return (
      <div className="container mx-auto p-4">
        <PageHeader title="数据库管理" />
        <Card className="mt-6">
          <CardContent className="p-6">
            <div className="text-center text-red-500">
              <p>您没有权限访问此页面</p>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto p-4 space-y-6">
      <PageHeader 
        title="数据库管理" 
        description="备份和恢复数据库" 
      />
      <DatabaseBackupRestore />
    </div>
  );
};

export default DatabasePage; 